type Props = {
  cardRows: readonly number[];
};

export function StatsLoadingCards({ cardRows }: Props) {
  return (
    <div
      className="tp-stats-skeleton"
      role="status"
      aria-label="загружаем статистику"
    >
      {cardRows.map((rowCount, cardIndex) => (
        <section
          key={`${cardIndex}-${rowCount}`}
          className="tp-stats-card tp-stats-skeleton-card"
          aria-hidden="true"
        >
          {Array.from({ length: rowCount }, (_, rowIndex) => (
            <div className="tp-stats-skeleton-row" key={rowIndex}>
              <span className="tp-stats-skeleton-line tp-stats-skeleton-label" />
              <span className="tp-stats-skeleton-line tp-stats-skeleton-value" />
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
